import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-input-switch-list',
  templateUrl: './input-switch-list.component.html',
  styleUrls: ['./input-switch-list.component.css'],
})
export class InputSwitchListComponent implements OnInit, OnDestroy {
  @Input() class: string;
  @Input() control: FormControl;
  @Input() switches: string[] = [];
  form: FormGroup;
  private onDestroy$: Subject<void> = new Subject();

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.form = this.fb.group({
      sws: this.fb.array([]),
    });
    const fa = this.form.controls.sws as FormArray;
    const enabled = this.control.value;

    for (const sw of this.switches) {
      fa.push(this.fb.control(enabled.indexOf(sw) !== -1));
    }

    this.form.valueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(() => this.onChange());
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  get sws() {
    return this.form.get('sws') as FormArray;
  }

  private onChange() {
    const values = this.form.controls.sws.value;
    const state = [];

    for (let i = 0, len = values.length; i < len; i++) {
      if (values[i]) state.push(this.switches[i]);
    }

    this.control.setValue(state);
    this.control.markAsDirty();
  }
}
